<template>
  <path
    d="M19.8 18.4002L14 10.6702V6.50024L15.35 4.81024C15.61 4.48024 15.38 4.00024 14.96 4.00024H9.03999C8.61999 4.00024 8.38999 4.48024 8.64999 4.81024L9.99999 6.50024V10.6702L4.19999 18.4002C3.70999 19.0602 4.17999 20.0002 4.99999 20.0002H19C19.82 20.0002 20.29 19.0602 19.8 18.4002Z"
  />
</template>
